import {createRef} from "../createRef";

export default createRef({
    "id": "didox_doc_type_ref",
    "source": "didox_doc_type_ref",
    "fields": [
        {"column": "id"},
        {"column": "name"}
    ]
});
